var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.487,
    height: 23.865,
    viewBox: "0 0 29.487 23.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-to-playlist",
    d: "M16.628,19.921h10.4a1.405,1.405,0,0,0,0-2.811h-10.4a1.405,1.405,0,1,0,0,2.811Zm0,7.027h10.4a1.405,1.405,0,0,0,0-2.811h-10.4a1.405,1.405,0,0,0,0,2.811Zm0,7.168H43.191a1.405,1.405,0,1,0,0-2.811H16.628a1.405,1.405,0,0,0,0,2.811Zm26.437,4.048H16.515a1.405,1.405,0,1,0,0,2.811H43.065a1.405,1.405,0,1,0,0-2.811ZM33.437,24.7h3.331v3.331a1.405,1.405,0,1,0,2.811,0V24.7h3.345a1.405,1.405,0,1,0,0-2.811H39.593V18.558a1.405,1.405,0,1,0-2.811,0v3.331H33.451a1.405,1.405,0,0,0,0,2.811Z",
    transform: "translate(-15.11 -17.11)",
    fill: "#fff",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.fab1febbc8ea043acf7b20f03c907378.svg";
export { ForwardRef as ReactComponent };